import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import moment from "moment"
import currentUser from "helpers/currentUser"
import settings from "settings"

class InfoWindow extends Component {
	constructor(props) {
		super(props)
		this.state = {
			height: 0,
			bottomOffset: 150,
			user: currentUser(),
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.lot !== this.props.lot) {
			//console.log(this.props.lot)
		}
	}

	parseSource = () => {
		let lot = this.props.lot
		//let lot = _.find(this.props.payload.exec.lots, { id: this.props.lot?.id })
		if (!lot) {
			return
		}
		let sec = _.find(this.props.payload.public.sections, { id: lot.section_id })
		let section = "n/a"
		if (sec) {
			section = sec.name
		}
		if (lot.builder) {
			// Lot is setup
			var builderId = lot.builder
			var b = _.find(this.props.payload.public.builders, {
				id: builderId,
			})
			var builderName = ""
			if (b) {
				builderName = b.name
			}
			var address = lot.address
			//? This logic will attempt to convert materials that are just numbers into their names from materials
			try {
				if (this.props.payload.public.arc_materials.length > 0) {
					_.forEach(lot, (v, k) => {
						if (!parseInt(v)) return // If it's not a number, don
						_.forEach(this.props.payload.public.arc_material_types, (m) => {
							if (m.dbName === k) {
								let material = _.find(this.props.payload.public.arc_materials, { id: parseInt(v) })
								if (material) {
									lot[k] = material.name
								}
							}
						})
					})
				}
			} catch (e) {
				console.log(e)
			}

			let complete = lot.complete_date
			let start = lot.start_date
			let takedown = lot.takedown_date
			var lbs = lot.lot + "-" + lot.block + "-" + section
			var id = lot.id
			let sales = lot.sales
			let buyers = lot.buyers
			let floorplan = lot.floorplan
			let elevation = lot.elevation
			let brick = lot.brick
			let garage_color = lot.garage_color
			let accent_color = lot.accent_color
			let roof_color = lot.roof_color
			let siding = lot.siding
			let siding_type = lot.siding_type
			let stucco = lot.stucco
			let stone = lot.stone
			let trim = lot.trim
			let model = lot.model
			let fp = _.find(this.props.payload.public.floorplans, { id: floorplan })
			let sold = false
			let sale = false
			let buyer = false
			let salePending = false
			_.forEach(sales, (v) => {
				if (v.closing_date) {
					sold = true
					sale = v
					// get buyer
					let b = _.find(buyers, { id: v.buyer_id })
					if (b) {
						buyer = b
					}
				}
				if (!v.cancel_date && !v.closing_date && !v.transfer_date && !v.bustout_date) {
					sale = v
					salePending = true
					let b = _.find(buyers, { id: v.buyer_id })
					if (b) {
						buyer = b
					}
				}
			})
			let status = ""
			if (complete) {
				status = "Complete"
			} else if (start) {
				status = "Start"
			} else if (takedown) {
				status = "Takedown"
			}
			let saleStatus = ""
			if (model === 1 && sold) {
				saleStatus = "Model/Closed"
			} else if (model === 1 && salePending) {
				saleStatus = "Model/Contract"
			} else if (sold) {
				saleStatus = "Sold"
			} else if (salePending) {
				saleStatus = "Sale Pending"
			} else {
				saleStatus = "Available"
			}

			let addl = ""
			let lotButton
			if (this.state.user.group == settings.groups.dev) {
				addl = (
					<>
						{(saleStatus == "Sold" || salePending) && (
							<>
								<p>
									<span className="infoWindow__subTitle">Buyer </span> {buyer.primary_first}{" "}
									{buyer.primary_last}
								</p>
								{/* {buyer.primary_email && (
								<p>
									<span className="infoWindow__subTitle">Buyer Email </span> {buyer.primary_email}
								</p>
							)} */}
								{saleStatus == "Sold" && (
									<>
										<p>
											<span className="infoWindow__subTitle">Closed Price </span>
											{sale.closing_price && `$` + sale.closing_price.toLocaleString()}
										</p>
										<p>
											<span className="infoWindow__subTitle">Closed Date </span>
											{moment.unix(sale.closing_date).format("MM/DD/YY")}
										</p>
									</>
								)}
								{salePending && (
									<>
										<p>
											<span className="infoWindow__subTitle">Sale Price </span>
											{sale.price && `$` + sale.price.toLocaleString()}
										</p>
										<p>
											<span className="infoWindow__subTitle">Sale Date </span>
											{moment.unix(sale.sale_date).format("MM/DD/YY")}
										</p>
									</>
								)}
							</>
						)}
					</>
				)
				if (this.props.openLot) {
					lotButton = (
						<p>
							<a className="infoWindow__view" onClick={() => this.props.openLot(id)}>
								VIEW LOT DETAILS
							</a>
						</p>
					)
				}
			}
			let arc = (
				<>
					{settings.arc && brick && (
						<>
							<p>
								<span className="infoWindow__subTitle">Brick </span>
								{brick}
							</p>
						</>
					)}
					{settings.arc && accent_color && (
						<>
							<p>
								<span className="infoWindow__subTitle">Accent Color </span>
								{accent_color}
							</p>
						</>
					)}
					{settings.arc && garage_color && (
						<>
							<p>
								<span className="infoWindow__subTitle">Garage Color </span>
								{garage_color}
							</p>
						</>
					)}
					{settings.arc && roof_color && (
						<>
							<p>
								<span className="infoWindow__subTitle">Roof Color </span>
								{roof_color}
							</p>
						</>
					)}
					{settings.arc && siding && (
						<>
							<p>
								<span className="infoWindow__subTitle">Siding </span>
								{siding}
							</p>
						</>
					)}
					{settings.arc && siding_type && (
						<>
							<p>
								<span className="infoWindow__subTitle">Siding Type </span>
								{siding_type}
							</p>
						</>
					)}
					{settings.arc && stone && (
						<>
							<p>
								<span className="infoWindow__subTitle">Stone </span>
								{stone}
							</p>
						</>
					)}
					{settings.arc && stucco && (
						<>
							<p>
								<span className="infoWindow__subTitle">Stucco </span>
								{stucco}
							</p>
						</>
					)}
					{settings.arc && trim && (
						<>
							<p>
								<span className="infoWindow__subTitle">Trim </span>
								{trim}
							</p>
						</>
					)}
				</>
			)
			return (
				<div className="infoWindow">
					<div className="infoWindow__right">
						<p>
							<span className="infoWindow__subTitle" title={id}>
								LBS
							</span>{" "}
							{lbs}
						</p>
						<p>
							<span className="infoWindow__subTitle">Builder</span> {builderName}
						</p>
						<p>
							<span className="infoWindow__subTitle">Address</span> {address}
						</p>
						<p>
							<span className="infoWindow__subTitle">Construction Status</span> {status}
						</p>
						<p>
							<span className="infoWindow__subTitle">Sale Status</span> {saleStatus}
						</p>
						{fp && (
							<>
								<p>
									<span className="infoWindow__subTitle">Floorplan </span>
									{fp.name}
								</p>
							</>
						)}
						{elevation && (
							<>
								<p>
									<span className="infoWindow__subTitle">Elevation </span>
									{elevation}
								</p>
							</>
						)}
						{addl}
						{arc}
						{lotButton}
					</div>
				</div>
			)
		} else {
			// Developer lot
			let lbs = lot.lot + "-" + lot.block + "-" + section
			let address = lot.address
			let id = lot.id
			return (
				<div className="infoWindow">
					<div className="infoWindow__right">
						<p>
							<span className="infoWindow__subTitle">LBS</span> {lbs}
						</p>
						<p>
							<span className="infoWindow__subTitle">Address</span> {address}
						</p>
						<p>
							<span className="infoWindow__subTitle">Developer Lot</span>
						</p>
						{this.state.user.group == 1 && (
							<p>
								<a className="infoWindow__view" onClick={() => this.props.openLot(id)}>
									VIEW LOT DETAILS
								</a>
							</p>
						)}
					</div>
				</div>
			)
		}
	}

	render() {
		return <div className="heatmap__lotInfo">{this.parseSource()}</div>
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(InfoWindow)
